import Stomp from 'stompjs'
import { BASE_URL, WS_TYPE } from '@/config/constant'
import { useStore } from 'vuex'

let stompClient: any
let num: number = 0
let timer: any = null
const pollTime: number = 20 //重连时间s
let store: any = null
//连接服务
export default function SxSocket() {
	store = store ?? useStore()
	return new Promise((resolve, reject) => {
		try {
			stompClient = Stomp.client(`${WS_TYPE}://${BASE_URL}/ws`)
			// stompClient = Stomp.client(`${WS_TYPE}://192.168.124.100:18443/ws`)
			stompClient.heartbeat.outgoing = 10000
			if (timer) clearInterval(timer)
			stompClient.connect(
				'admin',
				'qwer1234',
				(res) => {
					console.log('服务已连接')
					num = 0
					resolve(stompClient)
				},
				(err) => {
					if (err.command == 'ERROR') {
						console.log('订阅失败：')
					} else {
						if (timer) clearInterval(timer)
						timer = setInterval(() => {
							num++
							console.log(`连接服务器失败${pollTime}s后尝试重连,尝试连接${num}次........`)
							store.dispatch('subscribeData')
						}, pollTime * 1000)
					}
					reject(err)
				}
			)

			stompClient.debug = null
		} catch (error) {

		}

	}).catch(error => { console.log(error) })
}

